import axios from 'axios';
import { getEndpoint, getRequestHeaders } from './config'

export default function (sessionId: string) {
    return new Promise<any>((resolve, reject) => {
        axios
            .post(
                getEndpoint('sessions/{id}/complete', { id: sessionId }),
                null,
                getRequestHeaders(true)
            )
            .then(function (response: any) {
                resolve();
            })
            .catch(function (rs: any) {
                reject(rs);
            });
    });
}